import React, { useContext, useState } from 'react';
import { isPassword, isValidEmail } from '../../utils/regexValidation';
import { useNavigate } from 'react-router-dom';
import InputBox from '../../atomic/inputbox/InputBox';
import AtomicButton from '../../atomic/button/Button';
import { Alert, AlertTitle } from '@mui/material';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import responseErrorMapping from '../../utils/error.response.mapping';
import { Error404 } from '../error404/Error404';
import { useNativeNotificationFields } from '../../utils/reactNativeBridge';

const Login = () => {
  const { setLoginAPIResponse, onLogin, loginAPIResponse } = useContext(SignUpDataContext);
  const navigate = useNavigate();
  const [emailValue, setEmailValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [validationErrors, setValidationErrors] = useState(null);
  const RedirectToForgotPassword = () => navigate('/forgotpassword');
  const RedirectToSignup = () => navigate('/checkzipcode'); //After twilio approve it remove this uncmented
  const RedirectToOrderDashboard = async () => navigate('/');
  const RedirectToTermsAndCondition = () => navigate('/termsofservice');

  const { loading, success, message, data } = loginAPIResponse;
  const nativeNotificationFields = useNativeNotificationFields();

  const showIncorrectCredentials =
    success === false &&
    (message === 'Incorrect email or password!' || message === 'Incorrect password or email!');

  const showCatchBlockMessage = message === 'Something is seriouly wrong,This is last CATCH block';

  const showGenericLoginFailure =
    !loading &&
    success !== true &&
    success !== null &&
    data == null &&
    (message == null || message === '');

  const showLoginApiErrorAlert =
    showIncorrectCredentials || showCatchBlockMessage || showGenericLoginFailure;

  const onChangeHandler = (event) => {
    event.preventDefault();
    const value = event.target.value;
    const targetName = event.target.name;

    if (targetName === 'email') {
      setEmailValue(value);
    }
    if (targetName === 'password') {
      setPasswordValue(value);
    }
  };

  const handleLogin = async () => {
    let Errors = {};

    if (!isValidEmail(emailValue) || !emailValue || (emailValue && emailValue?.length >= 50)) {
      if (emailValue && emailValue?.length >= 50) {
        Errors.email = 'Invaild email or password';
      } else {
        Errors.email = 'Invaild email or password';
      }
    }

    //  uncomment code before going live

    // if (!isPassword(passwordValue) || !passwordValue || (passwordValue && passwordValue?.length >= 50)
    // ) {
    //     if (passwordValue && passwordValue?.length >= 50) {
    //         Errors.password = 'Invaild email or password'
    //     } else {
    //         Errors.password = 'Invaild email format'
    //     }
    // }

    if (Object.keys(Errors)?.length > 0) {
      setValidationErrors(Errors);
    } else {
      setValidationErrors(null);
      const payload = {
        email: emailValue,
        password: passwordValue,
        ...nativeNotificationFields,
      };
      const LonginInfo = await onLogin(payload);

      if (
        LonginInfo?.loginAPIResponse?.data?.CustomMessage === 'Successful logged in to kitchen user'
      ) {
        RedirectToOrderDashboard();
        window.location.reload();
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        marginTop: '50px',
        width: '420px',
      }}
    >
      <div style={{ fontSize: '28px', fontFamily: 'Inter Bold', color: '#3F3F6E' }}> Login</div>
      <div
        style={{
          //   textAlign: 'center',
          fontFamily: 'Inter Regular',
          fontSize: '14px',
          margin: '10px',
          textAlign: 'center',
          color: '#3F3F6E',
        }}
      >
        {' '}
        Stay on top of orders, resolve issues, and keep track of your business performance{' '}
        <span
          style={{
            position: 'relative',
            display: 'inline-block',
            fontFamily: 'Inter Bold',
          }}
        >
          All In One.
          <span
            style={{
              position: 'absolute',
              left: '-4px',
              bottom: '-6px',
              width: '120%',
              height: '6px',
              borderBottom: '4px solid rgb(252, 93, 27)',
              borderRadius: '20%',
              transform: 'rotate(-3deg)',
              content: "''",
            }}
          />
        </span>
      </div>
      {validationErrors !== null && (
        <Alert
          severity='error'
          sx={{
            width: '365px',
            border: 'solid 1px #E74C3C',
            backgroundColor: '#FDEDEB',
            color: 'red',
            marginTop: '20px',
          }}
        >
          <AlertTitle sx={{ fontSize: '14px', fontWeight: 600 }}>Error</AlertTitle>

          <ul>
            {Object.keys(validationErrors).map((el, index) => (
              <li style={{ fontSize: '14px', fontFamily: 'Inter ' }} key={index}>
                {' '}
                <strong>{validationErrors[el]}</strong>
              </li>
            ))}
          </ul>
        </Alert>
      )}

      {showLoginApiErrorAlert && (
        <Alert
          severity='error'
          sx={{
            width: '365px',
            border: 'solid 1px #E74C3C',
            backgroundColor: '#FDEDEB',
            color: 'red',
            marginTop: '20px',
          }}
        >
          <AlertTitle sx={{ fontSize: '14px', fontFamily: 'Inter Medium' }}>
            {showGenericLoginFailure ? 'Something went wrong' : responseErrorMapping(message)}
          </AlertTitle>
        </Alert>
      )}

      <InputBox
        type='text'
        label='Email'
        size='small'
        sx={{
          width: '400px',
          height: 'auto',
          margin: '10px 5px 5px 0px',
        }}
        name='email'
        value={emailValue}
        maxLength='50'
        error={
          validationErrors !== null &&
          validationErrors['email'] &&
          validationErrors['email'].length > 0
        }
        onChange={onChangeHandler}
      />

      <InputBox
        type='password'
        label='Password'
        size='small'
        sx={{
          width: '400px',
          height: 'auto',
          margin: '10px 5px 5px 0px',
        }}
        name='password'
        value={passwordValue}
        maxLength='50'
        error={
          validationErrors !== null &&
          validationErrors['password'] &&
          validationErrors['password'].length > 0
        }
        onChange={onChangeHandler}
      />

      <AtomicButton
        label='Login'
        handleSubmit={handleLogin}
        style={{ backgroundColor: '#181436', width: '400px' }}
        loading={false}
        disabled={false}
      />

      <div
        style={{
          fontFamily: 'Inter Regular',
          fontSize: '12px',
          margin: '10px',
          textAlign: 'justify',
          color: 'gray',
        }}
      >
        By logging in, you agree to SingleCombo's Merchant{' '}
        <span
          style={{ fontFamily: 'Inter Bold', color: 'black', cursor: 'pointer' }}
          onClick={RedirectToTermsAndCondition}
        >
          Security Terms.
        </span>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <div style={{ color: '#3F3F6E', fontSize: '15px' }}>
          {' '}
          Don't have an account? &nbsp;
          <span
            style={{
              cursor: 'pointer',
              fontFamily: 'Inter Regular',
              fontSize: '16px',
              color: '#5078e6',
            }}
            onClick={RedirectToSignup}
          >
            Sign up
          </span>
        </div>
        <div
          style={{
            cursor: 'pointer',
            fontFamily: 'Inter Regular',
            fontSize: '16px',
            color: '#5078e6',
          }}
          onClick={RedirectToForgotPassword}
        >
          Forgot password?
        </div>
      </div>
    </div>
  );
};

export default Login;
